var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMic = function SvgIcMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 19.684a4.415 4.415 0 0 0 4.42-4.42V6.42A4.415 4.415 0 0 0 16.2 2a4.415 4.415 0 0 0-4.422 4.421v8.842a4.415 4.415 0 0 0 4.421 4.421Zm8.709-4.42a1.47 1.47 0 0 0-1.444 1.252c-.605 3.463-3.626 6.116-7.266 6.116s-6.66-2.653-7.265-6.116a1.47 1.47 0 0 0-1.444-1.253c-.9 0-1.607.796-1.474 1.68.722 4.421 4.259 7.884 8.71 8.518v3.065c0 .81.663 1.474 1.473 1.474s1.474-.663 1.474-1.474v-3.065c4.45-.634 7.987-4.097 8.71-8.518.147-.884-.575-1.68-1.474-1.68Z"
  })));
};
export default SvgIcMic;